import axios from 'axios';

import {WorkingHoursInterval, WorkingHours as WorkingHoursType} from 'types';

import {API_URL} from './constants';

const url = `${API_URL}/settings`;

const getForPersonal = async (): Promise<WorkingHoursType> => {
    const res = await axios.get(`${url}/working-hours/me`);
    return res.data;
};

const updateForPersonal = async (workingHours: WorkingHoursType) => {
    const res = await axios.post(`${url}/working-hours/me`, workingHours);
    return res.data;
};

const getForUser = async (eid: number): Promise<WorkingHoursType> => {
    const res = await axios.get(`${url}/working-hours/user`, {params: {eid}});
    return res.data;
};

const updateForUser = async (workingHours: WorkingHoursType, eid: number) => {
    const res = await axios.post(`${url}/working-hours/user`, workingHours, {params: {eid}});
    return res.data;
};

const getForAssignment = async (groupId: string): Promise<WorkingHoursType> => {
    const res = await axios.get(`${url}/working-hours/assignment`, {params: {groupId}});
    return res.data;
};

const updateForAssignment = async (workingHours: WorkingHoursType, groupId: string) => {
    const res = await axios.post(`${url}/working-hours/assignment`, workingHours, {params: {groupId}});
    return res.data;
};

const getTimelineData = async (
    date: string, groupId: string
): Promise<{usersIntervals: {userName: string, intervals: WorkingHoursInterval[]}[], assignmentIntervals: WorkingHoursInterval[]}> => {
    const res = await axios.get(`${url}/working-hours/timeline`, {params: {date, groupId}});
    return res.data;
};

export const workingHoursApi = {
    getForPersonal,
    updateForPersonal,
    getForUser,
    updateForUser,
    getForAssignment,
    updateForAssignment,
    getTimelineData
};